






import Vue from 'vue';
import {Component, Prop } from 'vue-property-decorator';
import JdsIcon from "@/design-system/icons/JdsIcon.vue"
import JdsGlyph from "@/design-system/icons/JdsGlyph.vue"

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 */
@Component({
    components: {JdsGlyph, JdsIcon}
})
export default class JdsEntrySlot extends Vue {
}
